import React from "react";

import DailyReminderModal from "../DailyReminderModal";
import Panel from "../Panel";
import { trackAmplitudeEvent } from "../../amplitude";

export default class V5DailyReminderPrompt extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dailyReminderEmail: props.dailyReminderEmail,
      modalVisible: false
    };
  }

  componentDidMount() {
    trackAmplitudeEvent("web_app_daily_reminder_with_sentence_prompt_shown", this.amplitudeProps());
  }

  amplitudeProps(extra) {
    return Object.assign(
      {
        experiment: "daily_reminder_with_sentence",
        variant: "enabled"
      },
      this.props.amplitudeRoundProperties || {},
      extra || {}
    );
  }

  onSetClick() {
    trackAmplitudeEvent("web_app_daily_reminder_with_sentence_prompt_clicked", this.amplitudeProps());
    this.setState({ modalVisible: true });
  }

  renderModal() {
    if(!this.state.modalVisible) {
      return null;
    }

    return (
      <DailyReminderModal
        dailyReminderEmail={this.state.dailyReminderEmail}
        onHidden={() => this.setState({ modalVisible: false })}
        onUpdate={(dailyReminderEmail) => {
          trackAmplitudeEvent("web_app_daily_reminder_with_sentence_prompt_set", this.amplitudeProps({ daily_reminder_email: dailyReminderEmail }));
          this.setState({ dailyReminderEmail }, () => this.modal.hide());
        }}
        ref={(el) => this.modal = el}
        updateUrl={this.props.updateUrl}
      />
    );
  }

  render() {
    if(this.state.dailyReminderEmail) {
      return null;
    }

    return (
      <div className="v5-daily-reminder-prompt">
        <Panel>
          <div className="text-center">
            <div style={{ fontSize: "3rem", marginBottom: 8 }}>📬</div>
            <h3 className="v5-section-heading" style={{ marginTop: 0, marginBottom: 8 }}>
              Get tomorrow's sentence in your inbox
            </h3>
            <p style={{ marginBottom: 16 }}>
              We'll email you your next sentence so you can {this.props.showDaysPlayedInsteadOfStreak ? "keep learning every day" : "keep your streak alive"} in one tap.
            </p>
            <button
              className="btn btn-success joystix"
              disabled={!this.props.isSignedIn}
              onClick={() => this.onSetClick()}
            >
              Set a daily reminder
            </button>
          </div>
        </Panel>
        {this.renderModal()}
      </div>
    );
  }
}
